<template>
  <div class="c-input-number" >
    <button @click.prevent="decreaseNumber" :class="['button', {'disabled' : +value <= +min}]">
      <span class="text">-</span>
    </button>
    <input
      disabled
      type="number"
      v-bind:value="numericValue"
      @keypress="validateInput"
      autocomplete="new-password"
      class="input"
      :min="min"
      :max="max"
      debounce="500"
    />
    <button @click.prevent="increaseNumber" :class="['button', {'disabled' : +max <= +value}]">
      <span class="text">+</span>
    </button>
  </div>
</template>

<script>
export default {
  data() { return { numericValue: this.value } },
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    },
    integerOnly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    increaseNumber() { this.numericValue += this.step; },
    decreaseNumber() { this.numericValue -= this.step; },
    isInteger(evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.keyCode || evt.which;
      key = String.fromCharCode( key );
      const regex = /\d/;

      if( !regex.test(key) ) {
        evt.returnValue = false;
        if(evt.preventDefault) evt.preventDefault();
      }
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateInput(evt) {
      if ( this.integerOnly === true) {
        this.isInteger(evt);
      } else {
        this.isNumber(evt);
      }
    }
  },
  watch: {
    numericValue: function(val, oldVal){
      if (val <= this.min)
        this.numericValue = parseInt(this.min)

      if (val >= this.max)
        this.numericValue = parseInt(this.max)

      if (val <= this.max && val >= this.min)
        this.$emit('input', val, oldVal )
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@style/reference';

.c-input-number {
  display: flex;

  max-width: 130px;
  background-color: #FFF;
  border-radius: 20px;
  padding: 5px;

  border: 1px solid $border-color;

  .input {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    font-family: $title-font-family !important;

    height: 30px;
    width: calc(100% - 80px);
    flex-grow: 1;

    background-color: transparent;
    outline: none;
    margin: 0;
    border: 0;

    color: rgba($title-color, 0.3);

    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;

    border: 0;
    color: #fff;
    cursor: pointer;
    margin: 0;
    outline: none;

    height: 30px;
    width: 30px;

    line-height: 10px;
    border-radius: 50%;

    transition: opacity .5s ease;
    background-color: $primary-color-placeholder;
    background-color: var(--color-primary);

    -webkit-appearance: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    & > .text {
      margin: auto;
    }

    @include desktop {
      &:hover {
        background-color: $primary-color-placeholder;
        background-color: var(--color-primary);
        opacity: 0.5;
      }
    }

    &.disabled {
      pointer-events: none;
      cursor: default;
      background-color: $disabled-background;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CInputNumber.vue